export default __webpack_public_path__ + "static/media/puzzle.b03f2bc2.svg";